export enum AppRoutes {
  Root = "/publishers/panel",
  Auth = "/publishers/panel/auth",
  Books = "/publishers/panel/books",
  Statistics = "/publishers/panel/statistics",
  Activity = "/publishers/panel/activity",
  Campaigns = "/publishers/panel/campaigns",
  Feed = "/publishers/panel/feed",
  Balance = "/publishers/panel/balance",
  Publishers = "/publishers/panel/publishers",
}

/** Base for promo-campaign deep links (matches the Flutter app). */
export const DEEPLINK_BASE = "https://chytanka.com/campaigns";
